export const VERSION = 10;

export const ENVIRONMENT =
  process?.env.REACT_APP_ENVIRONMENT || (process?.env.NODE_ENV ?? 'development');

export const IS_PRODUCTION = ENVIRONMENT === 'production';
export const IS_STAGING = ['staging', 'test'].includes(ENVIRONMENT);
export const IS_DEVELOPMENT = !IS_PRODUCTION && !IS_STAGING;

export const ENDPOINT =
  process?.env.REACT_APP_ENDPOINT ||
  (IS_PRODUCTION
    ? 'api.tonplace.net'
    : IS_STAGING
    ? 'api.tonplace.host'
    : '127.0.0.1:8443');

export const PUBLIC_URL =
  process?.env.REACT_APP_PUBLIC_URL ||
  (IS_PRODUCTION
    ? 'https://ton.place'
    : IS_STAGING
    ? 'https://tonplace.host'
    : 'https://localhost:3000');

export const TELEGRAM_BOT_ID =
  process?.env.REACT_APP_TELEGRAM_BOT_ID ||
  (IS_PRODUCTION ? '2141264283' : IS_STAGING ? '8583923839' : '7914206939');

export const TELEGRAM_BOT_USERNAME =
  process?.env.REACT_APP_TELEGRAM_BOT_USERNAME ||
  (IS_PRODUCTION ? 'tonplace_bot' : IS_STAGING ? 'stagingtonplacebot' : 'tp_dev_env_bot');

export const TELEGRAM_LEGACY_BOT_ID =
  process?.env.REACT_APP_TELEGRAM_LEGACY_BOT_ID || TELEGRAM_BOT_ID;

export const API_URL = `https://${ENDPOINT}`;

export const CONTEST_CUP = 500;

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAFEGyZXe4lELSgrV5lhxH9kQp46KeUKm4',
  authDomain: 'tonplace-f69ec.firebaseapp.com',
  projectId: 'tonplace-f69ec',
  storageBucket: 'tonplace-f69ec.appspot.com',
  messagingSenderId: '465231271647',
  appId: '1:465231271647:web:16297769cf21d2d7f47b6a',
  measurementId: 'G-3P1EDPGWV6',
};

export const VAPID_KEY =
  'BBajoWxT1aQc8dubYyIVFnOg42hlZx3c7e2voeL3mjrtE3si-4fpmXzEgDN-zLZtcvccpktoir_CY4nnI4oHcx4';

export const SENTRY_DSN =
  'https://3caaefa4370b74b9b0eedd86c2e04523@o974650.ingest.us.sentry.io/4511586401058816';

// export const SENTRY_DSN =
//   process?.env.REACT_APP_SENTRY_DSN ||
//   'https://5f2e77c13517eb90e4af5edf992212e7@o4509593052184576.ingest.de.sentry.io/4509593053495376';

export const GOOGLE_CLIENT_ID =
  process?.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '88686137829-9fm957fko8fdlnptbrju9q8av1fmnmdh.apps.googleusercontent.com';

export const FORCE_GMAIL_OAUTH = ['y', '1', 'yes', true, 1].includes(
  process?.env.REACT_APP_FORCE_GMAIL_OAUTH || true,
);

// @ts-ignore
window.tp_print_config = () => {
  console.log(
    JSON.stringify({
      ENVIRONMENT: ENVIRONMENT,
      IS_PRODUCTION: IS_PRODUCTION,
      IS_STAGING: IS_STAGING,
      IS_DEVELOPMENT: IS_DEVELOPMENT,
      ENDPOINT: ENDPOINT,
      PUBLIC_URL: PUBLIC_URL,
      TELEGRAM_BOT_ID: TELEGRAM_BOT_ID,
      API_URL: API_URL,
      CONTEST_CUP: CONTEST_CUP,
      FIREBASE_CONFIG: FIREBASE_CONFIG,
      VAPID_KEY: VAPID_KEY,
      SENTRY_DSN: SENTRY_DSN,
      GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
      FORCE_GMAIL_OAUTH: FORCE_GMAIL_OAUTH,
      RAW: JSON.stringify(process.env),
    }),
  );
};
